<template>
  <v-container fluid pa-0 ma-0>
    <v-layout row wrap class="ma-0" v-scroll="onScroll">

      <v-toolbar class="pa-0 ma-0 extension-padding"
                 flat fixed scroll-off-screen
                 :style="{ backgroundColor: $route.name === 'ReadContent' ? 'transparent' : undefined }"
                 ref="toolbarPlayer">
        <v-btn flat icon @click="$router.go(-1)">
          <v-icon size="32px" color="#a9a9af">$vuetify.icons.navArrowLeft</v-icon>
        </v-btn>
        <h3 v-if="$route.name === 'ReadVideo'" class="display-2" style="margin-bottom: 2px">{{ post.user.name }}</h3>
        <v-spacer></v-spacer>
<!--        <v-btn :ripple="false"-->
<!--                icon-->
<!--                small-->
<!--                depressed-->
<!--                :dark="!channel.subscribes"-->
<!--                :outline="channel.subscribes"-->
<!--                :color="channel.subscribes ? null : 'primary'"-->
<!--                @click="subscribe(channel.idx)">-->
<!--          <v-icon size="10px"-->
<!--                  :color="channel.subscribes ? 'primary' : null"-->
<!--                  :dark="!channel.subscribes">-->
<!--            {{ channel.subscribes ? '$vuetify.icons.confirm' : '$vuetify.icons.add' }}-->
<!--          </v-icon>-->
<!--        </v-btn>-->
        <!-- 유튜브 비디오 플레이어 -->
        <template v-slot:extension v-if="post.type === 'video'">
          <v-img :src="post.thumbnail ? `https://i.ytimg.com/vi/${post.video_id}/hqdefault.jpg` : thumbnailSrc"
                 class="grey lighten-5"
                 :aspect-ratio="16/9">
            <iframe id="player" type="text/html" width="100%" height="100%" v-if="!isLoading"
                    :src="`https://www.youtube.com/embed/${post.video_id}?enablejsapi=1&origin=${origin}&playsinline=1&modestbranding=1`"
                    frameborder="0"></iframe>
          </v-img>
        </template>
      </v-toolbar>

      <v-flex xs12 v-if="isLoading">
        <v-progress-circular indeterminate style="margin: auto; margin-top: 100px;"></v-progress-circular>
      </v-flex>

      <!-- 일반 썸네일 -->
      <v-flex xs12 v-show="!isLoading" v-if="post.type !== 'video'">
        <v-img :src="post.thumbnail ? `${$storage}/post/${post.thumbnail}` : thumbnailSrc" :aspect-ratio="16/9"
               gradient="to bottom, transparent, rgba(0,0,0,0.5)">
          <v-layout pa-3 column fill-height class="text-xs-left">
            <v-spacer></v-spacer>
            <v-flex shrink>
              <div class="thumbnail-text-time">{{ published }}</div>
              <div class="thumbnail-text-title" v-text="post.title"></div>
            </v-flex>
          </v-layout>
        </v-img>
      </v-flex>

      <v-flex v-show="!isLoading" xs12 class="pb-2" :style="{ 'padding-top': post.type === 'video' ? paddingTop + 'px' : null }"
              ref="channelListTiles">
        <v-card tile flat class="pt-3 pb-4 card-shadow">
          <v-layout py-0 px-3 column class="text-xs-left" v-if="post.type === 'video'">
            <v-spacer></v-spacer>
            <v-flex shrink>
              <div class="thumbnail-text-time dark-text">{{ published }}</div>
              <div class="thumbnail-text-title dark-text" v-text="post.title"></div>
            </v-flex>
          </v-layout>
          <v-card-text class="pt-3 px-0 pb-0 ma-0 reader-style"
                       id="contentsHtml"
                       v-html="post.contents">
          </v-card-text>
          <v-card-text class="text-xs-right" style="font-size: 12px; letter-spacing: -0.5px; color: #707070" v-if="post.type === 'content'">
            본 포스팅의 저작권은 유스에 있으며<br>무단 전재 및 재배포를 금지합니다.
          </v-card-text>
        </v-card>
        <div ref="releaseActionBarPosition"></div>
<!--        <v-card tile flat class="card-shadow pa-0 ma-0">-->
<!--          <v-card-text class="pa-0 ma-0">-->
<!--            <ChannelListTile :idx="channel.idx"-->
<!--                             :title="channel.title"-->
<!--                             :introduce="channel.introduce"-->
<!--                             :subscribeCnt="channel.subscribe_cnt"-->
<!--                             :thumbnail="channel.thumbnail"-->
<!--                             :subscribes="channel.subscribes"-->
<!--                             @subscribe="subscribe(channel.idx)" />-->
<!--          </v-card-text>-->
<!--        </v-card>-->
      </v-flex>

<!--      <v-flex v-show="!isLoading" xs12 class="pb-2" ref="releaseActionBarPosition">-->
<!--        <v-card tile class="card-shadow pa-0 ma-0">-->
<!--          <v-list class="pa-0" style="background-color: #f8f8f8;">-->
<!--            <v-subheader>관련 채널</v-subheader>-->
<!--            <template v-for="(channel, index) in relatedChannels">-->
<!--              <ChannelListTile :key="index"-->
<!--                               :idx="channel.idx"-->
<!--                               :title="channel.title"-->
<!--                               :introduce="channel.introduce"-->
<!--                               :subscribeCnt="channel.subscribe_cnt"-->
<!--                               :thumbnail="channel.thumbnail"-->
<!--                               :subscribes="channel.subscribes"-->
<!--                               @subscribe="subscribe(channel.idx)" />-->
<!--            </template>-->
<!--          </v-list>-->
<!--        </v-card>-->
<!--      </v-flex>-->

      <v-footer v-show="!isLoading"
                height="56px"
                :fixed="fixedActionBar"
                color="white"
                style="width: 100%;"
                :style="{ position: fixedActionBar ? '' : 'relative' }">
        <v-card class="flex px-3" flat tile>
          <v-layout row align-center>
            <v-btn icon small class="ma-0" @click="share">
              <v-icon>$vuetify.icons.share</v-icon>
            </v-btn>

            <v-spacer></v-spacer>

            <v-layout align-center justify-end style="flex-grow: 0;">
              <v-layout column align-center class="mr-4">
                <v-btn icon small class="ma-0" @click="scrollToComment">
                  <v-icon>$vuetify.icons.commentOutlined</v-icon>
                </v-btn>
                <span class="counter" v-text="post.comment_cnt"></span>
              </v-layout>

              <v-layout column align-center class="mr-4">
                <v-btn icon small @click="like(post.idx)" class="ma-0">
                  <v-icon :color="post.likes ? '#ec2f54' : ''">{{ post.likes ? '$vuetify.icons.heartFilled' : '$vuetify.icons.heartOutlined' }}</v-icon>
                </v-btn>
                <span class="counter" v-text="post.like_cnt"></span>
              </v-layout>

              <v-layout column align-center>
                <v-btn icon small @click="bookmark(post.idx)" class="ma-0">
                  <v-icon :color="post.bookmarks ? '#4a4a4a' : ''">{{ post.bookmarks ? '$vuetify.icons.bookmarkFilled' : '$vuetify.icons.bookmarkOutlined' }}</v-icon>
                </v-btn>
                <span class="counter" v-text="post.bookmark_cnt"></span>
              </v-layout>
            </v-layout>

          </v-layout>
        </v-card>
      </v-footer>

      <v-flex v-show="!isLoading" xs12>
        <v-card tile flat class="card-shadow pa-0 ma-0">
          <v-list class="pa-0 px-3">
            <v-subheader class="pa-0 justify-space-between caption">
              <span @click="readComments">총 {{ post.comment_cnt }}개의 댓글 중 인기 {{ post.comments.length }}개</span>
<!--              <span>조회 {{ post.view_cnt }}</span>-->
            </v-subheader>
            <CommentListTile v-for="(comment, index) of post.comments" :key="index"
                             :idx="comment.idx"
                             :postIdx="comment.post_idx"
                             :createdAt="comment.created_at"
                             :updatedAt="comment.updated_at"
                             :contents="comment.contents"
                             :likeCnt="comment.like_cnt"
                             :likes="comment.likes"
                             :user="comment.user"
                             :recommentCnt="comment.recomment_cnt"
                             :recomments="comment.recomments"
                             @like="likeReply"
                             @comment="recomment"
                             @report="reportReply"
                             @remove="removeReply"
                             @moreRecomment="selectMore" />
          </v-list>
          <div class="d-flex pa-3" style="background-color: #f8f8f8;">
            <v-text-field class="border-radius-custom"
                          solo flat hide-details
                          append-icon="게시"
                          placeholder="댓글"
                          v-model="comment"
                          ref="comment"
                          @click:append="submitComment"
                          @keyup.enter="submitComment">
            </v-text-field>
          </div>
          <div class="d-flex pa-3">
            <v-btn block round outline @click="readComments">댓글 더보기</v-btn>
          </div>
        </v-card>
      </v-flex>

      <v-flex v-show="!isLoading" xs12>
        <v-card tile class="pt-4 pb-2 mt-2 card-shadow">
          <v-card-title primary-title class="pb-0 pt-1 text-xs-left">
            <h1 class="display-4">비슷한 컨텐츠 추천</h1>
          </v-card-title>

          <v-card-text class="ma-0 pt-4 pl-0 pr-0 pb-0">
            <div v-for="(content, index) of similarContents" :key="index" class="px-3">
              <ContentCard :idx="content.idx"
                           :type="content.type"
                           :video_id="content.video_id"
                           :thumbnail="content.thumbnail"
                           :title="content.title"
                           :subtitle="post.subtitle"
                           :subtitle_color="post.subtitle_color"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import CommentListTile from '@/components/CommentListTile';
  import ContentCard from '@/components/ContentCard';
  import { timeToString, copyLink } from '@/util/util'

  export default {
    name: 'Content',
    props: [ 'idx' ],
    components: { CommentListTile, ContentCard },
    computed: {
      ...mapGetters('post', [ 'channel', 'post', 'relatedChannels', 'similarContents' ]),
      thumbnailSrc () {
        return require('@/assets/img/thumbnail-default.png');
      },
      origin () {
        return window.location.origin;
      },
      published () {
        return this.post.type === 'video' ? timeToString(this.post.published_at) : timeToString(this.post.created_at);
      }
    },
    data () {
      return {
        time: parseInt(new Date().getTime() / 1000),
        isLoading: true,
        fixedActionBar: true,
        paddingTop: (window.innerWidth * 9 / 16) + 48,
        comment: '',
        recommentTo: -1, // commentIdx,
        imageNodes: []
      };
    },
		metaInfo () {
			return {
				title: this.post.title + ' - 유스',
				meta: [
					// SEO 설정
					{ name: 'description', content: this.post.contents },
					// SNS 설정
					{ property: 'og:title', content: this.post.title + ' - 유스' },
					{ property: 'og:description', content: this.post.contents },
					{ property: 'og:url', content: "https://www.youth.lol" + window.location.pathname },
					// 모바일 최적화
					{ name: 'viewport', content: 'width=device-width, initial-scale=1' }
				]
			}
		},
    created () {
      this.selectPost(this.idx).then(() => {
        this.isLoading = false;
      });
    },
    destroy () {
      this.imageNodes.forEach(el => {
        el.removeEventListener('click', this.viewImage);
      });
    },
    watch: {
      comment (text) {
        if (text === '') {
          this.recommentTo = -1;
        }
      },
      idx (idx, oldIdx) {
        this.isLoading = true;
        if (idx !== oldIdx) this.selectPost(idx).then(() => {
          this.isLoading = false;
        });
      },
      'post.contents' (val) {
        this.imageNodes.forEach(el => {
          el.removeEventListener('click', this.viewImage);
        });
        if (val) {
          this.$nextTick(() => {
            this.imageNodes = document.getElementById('contentsHtml').querySelectorAll('img');
            // console.log(this.imageNodes);
            this.imageNodes.forEach(el => {
              el.addEventListener('click', this.viewImage);
            });
          });
        }
      }
    },
    methods: {
      ...mapActions([ 'toggleImageViewer' ]),
      ...mapMutations('post', {
        mutateToggleSubscription: 'TOGGLE_SUBSCRIPTION',
        mutationToggleLike: 'TOGGLE_LIKE',
        mutationToggleBookmark: 'TOGGLE_BOOKMARK' }),
      ...mapActions('post', [
        'selectPost', 'toggleLike', 'toggleBookmark', 'createComment', 'createRecomment',
        'toggleLikeComment', 'toggleLikeRecomment',
        'reportComment', 'reportRecomment', 'deleteComment', 'deleteRecomment', 'selectRecomments',
      ]),
      ...mapActions('channel', [ 'toggleSubscription' ]),
      viewImage (e) {
        this.toggleImageViewer({ flag: true, images: [ e.target.src ], startIndex: 0 });
      },
      onScroll () {
        this.fixedActionBar = window.scrollY <= this.$refs.releaseActionBarPosition.offsetTop - window.innerHeight + this.$refs.releaseActionBarPosition.scrollHeight + 56;
      },
      subscribe (idx) {
        this.toggleSubscription(idx).then(response => {
          this.mutateToggleSubscription({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      like (idx) {
        this.toggleLike(idx).then(response => {
          this.mutationToggleLike({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      bookmark (idx) {
        this.toggleBookmark(idx).then(response => {
          this.mutationToggleBookmark({ idx, flag: response.data });
        }).catch(err => {
          console.error(err);
        });
      },
      scrollToComment () {
        // window.scrollTo(0, this.$refs.releaseActionBarPosition.offsetTop + this.$refs.releaseActionBarPosition.scrollHeight);
        window.scrollTo({
          top: this.$refs.releaseActionBarPosition.offsetTop + this.$refs.releaseActionBarPosition.scrollHeight,
          behavior: 'smooth',
        });
      },
      submitComment () {
        if (this.comment === '') return false;
        if (this.recommentTo > -1) {
          this.createRecomment({ postIdx: this.idx, commentIdx: this.recommentTo, content: this.comment }).then(() => {
            // window.scrollTo(0, this.$refs.channelListTiles.offsetHeight + 400); // TODO: recomment 작성한 글위치로 스크롤
            this.comment = '';
          })
        } else {
          this.createComment({ idx: this.idx, content: this.comment }).then(() => {
            window.scrollTo(0, this.$refs.channelListTiles.offsetHeight + 400);
            this.comment = '';
          });
        }
      },
      likeReply (payload) {
        // console.log('likecomment', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.toggleLikeComment({ postIdx: payload.postIdx, commentIdx: payload.idx });
        } else {
          this.toggleLikeRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx });
        }
      },
      recomment (payload) {
        // console.log('recomment', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.comment = `@${payload.commentUserName} `;
          this.recommentTo = payload.idx;
        } else {
          this.comment = `@${payload.commentUserName} `;
          this.recommentTo = payload.commentIdx;
        }
        this.$refs.comment.focus();
      },
      reportReply (payload) {
        // console.log('report', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.reportComment({ postIdx: payload.postIdx, commentIdx: payload.idx }).then(response => {
            if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
            else this.showSnackbar('댓글이 신고되었습니다.');
          }).catch(err => {
            console.error(err);
          });
        } else {
          this.reportRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx }).then(response => {
            if (!response.data) this.showSnackbar('이미 신고한 댓글입니다.');
            else this.showSnackbar('댓글이 신고되었습니다.');
          }).catch(err => {
            console.error(err);
          });
        }
      },
      removeReply (payload) {
        // console.log('remove', payload);
        if (typeof payload.commentIdx === 'undefined') {
          this.deleteComment({ postIdx: payload.postIdx, commentIdx: payload.idx });
        } else {
          this.deleteRecomment({ postIdx: payload.postIdx, commentIdx: payload.commentIdx, recommentIdx: payload.idx });
        }
      },
      readComments () {
        if (this.post.type === 'video') {
          this.$router.push({ name: 'ReadVideoComment', params: { idx: this.idx, type: this.post.type } });
        } else {
          this.$router.push({ name: 'ReadContentComment', params: { idx: this.idx, type: this.post.type } });
        }
      },
      selectMore (payload) {
        if (payload.recommentOffset <= payload.recommentCnt) {
          this.selectRecomments({ second: this.time, postIdx: this.idx, commentIdx: payload.commentIdx, offset: payload.recommentOffset });
        }
      },
      share () {
        copyLink(window.location.href);
        // this.showSnackbar('링크가 복사되었습니다.');
        alert('링크가 복사되었습니다.');
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/.extension-padding .v-toolbar__extension {
    height: auto !important;
    padding: 0;
  }

  /deep/.v-btn--depressed {
    border-color: #cdcdcd !important;
  }

  .thumbnail-text {
    &-time {
      opacity: 0.8;

      font-size: 14px;
      font-weight: 700;
      letter-spacing: -0.3px;
      color: white;
      &.dark-text {
        color: map_get($colors, charcoal);
      }
    }
    &-title {
      font-size: 20px;
      font-weight: 700;
      letter-spacing: -0.3px;
      line-height: 24px;
      color: white;
      &.dark-text {
        color: map_get($colors, charcoal);
      }
    }
  }
  .body-1 {
    line-height: 20px;
    word-break: keep-all;
    word-wrap: break-word;
  }

  /deep/.card-shadow {
    box-shadow: 0 2px 3px map-get($colors, background-shadow);
  }

  /deep/.border-radius-custom {
    overflow: hidden;
    border-radius: 21px !important;
    .v-input__slot {
      cursor: pointer !important;
      padding: 0 18px !important;
    }
    input {
      cursor: pointer !important;
    }
    .v-icon {
      color: map_get($colors, primary);
      font-size: 12px;
    }
  }

  /deep/ .v-btn__content {
    flex-direction: column;
    & > span {
      font-size: 10px;
      line-height: 14px;
      font-weight: 700;
      letter-spacing: -0.2px;
      color: map_get($colors, charcoal);
    }
  }
  .counter {
    color: map_get($colors, charcoal);
    font-size: 10px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: -0.2px;
  }

</style>
